<template>
<div>
    <Breadcrumbs main="Sales" submain="Collection" title="Due Collection" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card p-4">

                    <!-- Top Summary -->
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <p><strong class="mr-1">Customer Name:</strong>{{ info?.customer?.name }}</p>
                            <p><strong class="mr-1" v-if="info?.customer?.mobile">Customer Mobile No:</strong> {{ info?.customer?.mobile }}</p>

                        </div>

                        <div class="col-md-6">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <p><strong>Total Amount</strong></p>

                                </div>
                                <div class="text-right">
                                    <p>{{ info?.total_amount }}</p>

                                </div>

                                <div class="ml-4">

                                    <p><strong>Total Due</strong></p>
                                </div>
                                <div class="text-right">

                                    <p>{{ info?.total_due }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Form Section -->
                    <div class="row">

                        <!-- Date -->
                        <div class="col-md-3 mb-3">
                            <label>Date</label>
                            <input type="date" class="form-control" v-model="form.date" />
                        </div>

                        <!-- Office -->
                        <div class="col-md-2 mb-3">
                            <label>Office</label>
                            <select class="form-control" v-model="form.office">
                                <!-- <option>MGM Head Office</option> -->
                            </select>
                        </div>

                        <!-- Payment Method -->
                        <div class="col-md-2 mb-3 ">
                            <label>Payment Method</label>
                            <select class="form-control" v-model="form.payment_method">
                                <option disabled value="">Select Payment Method</option>
                                <option v-for="method in paymentMethods" :key="method.value" :value="method.value">
                                    {{ method.label }}
                                </option>
                            </select>

                        </div>

                        <!-- Cash Type -->
                        <div class="col-md-2 mb-3">
                            <label>Cash Type</label>
                            <select class="form-control" v-model="form.cash_type">
                                <option>Cash Type</option>
                            </select>
                        </div>

                        <!-- Money Receipt -->
                        <div class="col-md-3 mb-3">
                            <label>Money Receipt No</label>
                            <input type="text" class="form-control" v-model="form.receipt_no" placeholder="Money Receipt No" />
                        </div>

                        <!-- Remarks -->
                        <div class="col-md-7 mb-3">
                            <label>Remarks</label>
                            <input type="text" class="form-control" v-model="form.remarks" placeholder="Remarks" />
                        </div>

                    </div>

                    <div class="row">

                        <!-- Department -->
                        <div class="col-md-4 mb-3">
                            <label>Employee (Department)</label>
                            <b-form-select v-model="selectedDepartment" :options="formattedDepartment"></b-form-select>
                        </div>

                        <!-- Designation -->
                        <div class="col-md-4 mb-3" v-if="selectedDepartment">
                            <label>Designation</label>
                            <b-form-select v-model="selectedDesignation" :options="formattedDesignation"></b-form-select>
                        </div>

                        <!-- Employee -->
                        <div class="col-md-4 mb-3" v-if="selectedDesignation">
                            <label>Employee</label>
                            <b-form-select v-model="form.employee" :options="formattedEmployee"></b-form-select>
                        </div>

                    </div>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">

                    <!-- <div class="card-header" style="width: 100%">
                        <div style="max-width: fit-content">
                            <router-link to="/sales/invoice/create/new">
                                <button class="btn btn-primary" type="submit" style="display: flex; align-items: center;">
                                    <div style="display: flex; gap: 12px; align-items: center; color: white;">
                                        <i class="fa fa-light fa-plus"></i>
                                        <h7>Add New Invoice</h7>
                                    </div>
                                </button>
                            </router-link>
                        </div>
                    </div> -->

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <div class="d-flex flex-wrap" style="gap: 10px;">
                                    <b-input-group class="datatable-btn" style="width: 340px;">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #563EE0; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                                        <feather type="filter"></feather>
                                        <h7>Filter</h7>
                                    </div>

                                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="start_date || end_date || status || client || project ">
                                        <feather type="x"></feather>
                                        <h7>Clear All</h7>
                                    </div>
                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div class="row mt-2" v-if="filterShow">
                            <div class="col-md-12">
                                <div class="grid-container mt-sm-0">
                                    <div class="grid-item">
                                        <datepicker placeholder="Start Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="start_date"></datepicker>
                                    </div>
                                    <div class="grid-item">
                                        <datepicker placeholder="End Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="end_date"></datepicker>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-select v-model="status" :options="formattedStatus"></b-form-select>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-select v-model="project" :options="formattedProjects"></b-form-select>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-select v-model="client" :options="formattedClients"></b-form-select>
                                    </div>
                                    <!-- <div class="grid-item">
                                        <b-form-select v-model="selectedDepartment" :options="formattedDepartment"></b-form-select>
                                    </div>
                                    <div class="grid-item" v-if="selectedDepartment">
                                        <b-form-select v-model="selectedDesignation" :options="formattedDesignation"></b-form-select>
                                    </div>
                                    <div class="grid-item" v-if="selectedDesignation">
                                        <b-form-select v-model="selectedEmployee" :options="formattedEmployee"></b-form-select>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue" style="margin-top: 22px;">
                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(select)="row">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" :id="'check-' + row.item.invoice_id" :value="Number(row.item.invoice_id)" v-model="selected">
                                            <label class="form-check-label" :for="'check-' + row.item.invoice_id">

                                            </label>
                                        </div>
                                    </template>
                                    <!-- Index -->
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <!-- Invoice -->
                                    <template #cell(invoice_no)="data">

                                        <router-link :to="`/sales/invoice/${data.item.invoice_no}`"><span class="font-weight-bold text-primary">{{ data.item.invoice_no }}</span></router-link>

                                    </template>

                                    <!-- Challan -->
                                    <template #cell(challan_no)="data">
                                        <span v-if="data.item.challan_no">
                                            {{ data.item.challan_no }}
                                        </span>
                                        <span v-else class="text-muted">—</span>
                                    </template>

                                    <!-- Delivery Date -->
                                    <template #cell(delivery_date)="data">
                                        <span v-if="data.item.delivery_date">
                                            {{ data.item.delivery_date }}
                                        </span>
                                        <span v-else class="text-muted">Pending</span>
                                    </template>

                                    <!-- Aging -->
                                    <template #cell(aging_days)="data">
                                        <span :class="data.item.aging_days > 30 ? 'text-danger' : 'text-success'">
                                            {{ data.item.aging_days }} days
                                        </span>
                                    </template>

                                    <!-- Amount Formatting -->
                                    <template #cell(net_amount)="data">
                                        ৳ {{ Number(data.item.net_amount).toFixed(2) }}
                                    </template>

                                    <template #cell(due_amount)="data">
                                        <span :class="data.item.due_amount > 0 ? 'text-danger' : 'text-muted'">
                                            ৳ {{ Number(data.item.due_amount).toFixed(2) }}
                                        </span>
                                    </template>
                                    <!-- Collection -->
                                    <template #cell(collection_amount)="data">
                                        <input type="number" class="form-control form-control-sm" v-model.number="getLine(data.item.invoice_id).collection_amount" placeholder="0.00" />
                                    </template>

                                    <!-- AIT -->
                                    <template #cell(ait)="data">
                                        <input type="number" class="form-control form-control-sm" v-model.number="getLine(data.item.invoice_id).ait" placeholder="0.00" />
                                    </template>

                                    <!-- VAT -->
                                    <template #cell(vat)="data">
                                        <input type="number" class="form-control form-control-sm" v-model.number="getLine(data.item.invoice_id).vat" placeholder="0.00" />
                                    </template>

                                    <!-- Adjustment -->
                                    <template #cell(adjustment)="data">
                                        <input type="number" class="form-control form-control-sm" v-model.number="getLine(data.item.invoice_id).adjustment" placeholder="0.00" />
                                    </template>

                                    <!-- Discount -->
                                    <template #cell(discount)="data">
                                        <input type="number" class="form-control form-control-sm" v-model.number="getLine(data.item.invoice_id).discount" placeholder="0.00" />
                                    </template>

                                    <!-- Actions -->
                                    <template #cell(action)="data">
                                        <div class="d-flex align-items-center" style="gap: 10px;">

                                            <!--                                             
                                            <router-link :to="`/sales/invoice/view/${data.item.invoice_id}`">
                                                <feather type="eye" size="18" class="text-info" style="cursor: pointer;" v-b-tooltip.hover title="View" />
                                            </router-link> -->

                                        </div>
                                    </template>

                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>
                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                        <div class="d-flex align-items-end justify-content-end mt-3" style="gap: 8px;">
                            <button class="btn btn-secondary" @click="createBill()">Create Bill</button>
                            <button class="btn btn-primary" @click="confirmCollection()">Confirm Collection</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this invoice?</div>
    </b-modal>

    <!-- Record Payment -->
    <b-modal id="modal-record" ref="modal" title="Record Payment" @show="resetModal" @hidden="resetModal" @ok="handleRecordOk">
        <form ref="form" @submit.stop.prevent="handleRecordSubmit">
            <b-form-group label="Amount" label-for="name-input" invalid-feedback="Item is required">
                <b-form-input id="name-input" v-model="record.paid_amount" placeholder="Enter Amount"></b-form-input>
            </b-form-group>
        </form>
    </b-modal>

    <b-modal id="modal-prevent-closing" ref="modal" title="Update Invoice Status" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group label="Status" label-for="name-input">
                <b-form-select v-model="selectedStatus" :options="statuses"></b-form-select>
            </b-form-group>
        </form>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import {
    data
} from 'vue2-dropzone';

export default {
    components: {
        Datepicker
    },

    data() {
        return {
            form: {
                customer: null,
                office: null,
                employee: null,
                payment_method: null,
                cash_type: null,
                money_receipt_no: '',
                date: null,
                remarks: '',

            },
            paymentMethods: [{
                    label: 'Cash',
                    value: 'cash'
                },
                {
                    label: 'Bank',
                    value: 'bank'
                },
                {
                    label: 'Wallet',
                    value: 'wallet'
                },
                {
                    label: 'Clear Invoice',
                    value: 'clear'
                }
            ],
            tablefields: [{
                    key: 'select',
                    label: ''
                },
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'invoice_no',
                    label: 'Invoice No',
                    sortable: true
                },
                {
                    key: 'challan_no',
                    label: 'Challan No',
                    sortable: true
                },
                {
                    key: 'delivery_date',
                    label: 'Delivery Date',
                    sortable: true
                },
                {
                    key: 'aging_days',
                    label: 'Aging (Days)',
                    sortable: true
                },
                {
                    key: 'net_amount',
                    label: 'Net Amount',
                    sortable: true
                },

                {
                    key: 'due_amount',
                    label: 'Due',
                    sortable: true
                },
                {
                    key: 'collection_amount',
                    label: 'Collection',
                    sortable: true
                },
                {
                    key: 'vat',
                    label: 'VAT',
                    sortable: true
                },
                {
                    key: 'ait',
                    label: 'AIT',
                    sortable: true
                },
                {
                    key: 'adjustment',
                    label: 'Adjustment',
                    sortable: true
                },
                {
                    key: 'discount',
                    label: 'Discount',
                    sortable: true
                },
                // {
                //     key: 'action',
                //     label: 'Action'
                // }
            ],
            record: {
                paid_amount: '',
                invoice: '',
            },
            invoice_due: '',
            initialLoad: true,
            isModifyingDate: false,

            filterShow: false,
            filter: null,
            start_date: null,
            end_date: null,
            status: '',
            client: '',
            project: '',
            selectedDepartment: '',
            selectedDesignation: '',
            selectedEmployee: '',
            delete_value: null,

            selectedStatus: null,
            update_id: null,
            statuses: ['DUE', 'FULLY-PAID', 'PARTIALLY-PAID'],
            statusOptions: [{
                    text: 'Due',
                    value: 'DUE'
                },
                {
                    text: 'Fully Paid',
                    value: 'FULLY-PAID'
                },
                {
                    text: 'Partially Paid',
                    value: 'PARTIALLY-PAID'
                }
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],
            lines: [],
            selected: [],
        };
    },

    computed: {
        ...mapState({
            items: state => state.order.sales_collection_by_customer,
            count: state => state.order.sales_count_by_customer,
            info: state => state.order.customer_info,
            loading: state => state.order.submitLoading,
            error: state => state.order.submitError,
            department_list: state => state.department.departments,
            designation_list: state => state.department.designation_by_department,
            employee_list: state => state.department.employee_by_designation,
            projects: state => state.project.project,
            clients: state => state.client.client_without_pg
        }),

        formattedProjects() {
            return [{
                    value: '',
                    text: 'Select a project',
                    disabled: true
                },
                ...this.projects.map(status => ({
                    value: status.id,
                    text: status.title
                }))
            ];
        },

        formattedStatus() {
            return [{
                    value: '',
                    text: 'Select a status',
                    disabled: true
                },
                ...this.statusOptions.map(status => ({
                    value: status.value,
                    text: status.text
                }))
            ];
        },

        formattedClients() {
            return [{
                    value: '',
                    text: 'Select a client',
                    disabled: true
                },
                ...this.clients.map(client => ({
                    value: client.user.id,
                    text: client.company_name
                }))
            ];
        },

        formattedEmployee() {
            return [{
                    value: '',
                    text: 'Select a Employee',
                    disabled: true
                },
                ...this.employee_list.map(emp => ({
                    value: emp.id,
                    text: emp.full_name
                }))
            ];
        },

        formattedDesignation() {
            return [{
                    value: '',
                    text: 'Select Designation',
                    disabled: true
                },
                ...this.designation_list.map(desg => ({
                    value: desg.id,
                    text: desg.title
                }))
            ];
        },

        formattedDepartment() {
            return [{
                    value: '',
                    text: 'Select Department',
                    disabled: true
                },
                ...this.department_list.map(dept => ({
                    value: dept.id,
                    text: dept.name
                }))
            ];
        }
    },

    watch: {
        items: {
            handler(val) {
                this.lines = val.map(item => ({
                    invoice_id: item.invoice_id,
                    collection_amount: 0,
                    ait: 0,
                    vat: 0,
                    adjustment: 0,
                    discount: 0
                }))
            },
            immediate: true
        },
        selectedDepartment(newVal, oldVal) {
            this.$store.dispatch("department/fetchDesignationByDepartment", newVal)
        },

        selectedDesignation(newVal, oldVal) {
            this.$store.dispatch("department/fetchEmployeeByDesignation", newVal)
        },

        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/sales/invoice/list',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });
                this.currentPage = newCurrentPage
                this.$store.dispatch("order/fetchSalesCollectionByCustomer", {
                    customer: this.$route.params.id,
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    client: this.client,
                    project: this.project,
                    employee: this.selectedEmployee,

                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/sales/invoice/list',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    }
                });
                this.perPage = newperPage
                this.$store.dispatch("order/fetchSalesCollectionByCustomer", {
                    customer: this.$route.params.id,
                    perPage: newperPage,
                    currentPage: this.currentPage,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    client: this.client,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        start_date(newVal, oldVal) {
            if (!this.initialLoad) {
                if (!this.isModifyingDate) {
                    this.isModifyingDate = true;
                    if (this.start_date !== null) {
                        this.start_date = moment(String(this.start_date)).format("YYYY-MM-DD");

                        this.$store.dispatch("order/fetchSalesCollectionByCustomer", {
                            customer: this.$route.params.id,
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            search_term: this.filter,
                            status: this.status,
                            client: this.client,
                            project: this.project,
                            employee: this.selectedEmployee
                        }).then(() => {
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false;
                        });
                    } else {
                        this.$store.dispatch("order/fetchSalesCollectionByCustomer", {
                            customer: this.$route.params.id,
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            search_term: this.filter,
                            status: this.status,
                            client: this.client,
                            project: this.project,
                            employee: this.selectedEmployee
                        }).then(() => {
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false;
                        });
                    }
                }

            }

        },

        end_date(newVal, oldVal) {
            if (!this.initialLoad) {
                if (!this.isModifyingDate) {
                    this.isModifyingDate = true;
                    if (this.end_date !== null) {
                        this.end_date = moment(String(this.end_date)).format("YYYY-MM-DD");

                        this.$store.dispatch("order/fetchSalesCollectionByCustomer", {
                            customer: this.$route.params.id,
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            search_term: this.filter,
                            status: this.status,
                            client: this.client,
                            project: this.project,
                            employee: this.selectedEmployee
                        }).then(() => {
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false;
                        });
                    } else {
                        this.$store.dispatch("order/fetchSalesCollectionByCustomer", {
                            customer: this.$route.params.id,
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            search_term: this.filter,
                            status: this.status,
                            client: this.client,
                            project: this.project,
                            employee: this.selectedEmployee
                        }).then(() => {
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false;
                        });
                    }
                }

            }

        },

        filter(newVal, oldVal) {
            if (!this.initialLoad) {

                this.$store.dispatch("order/fetchSalesCollectionByCustomer", {
                    customer: this.$route.params.id,
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    client: this.client,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },

        status(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("order/fetchSalesCollectionByCustomer", {
                    customer: this.$route.params.id,
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    client: this.client,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },

        client(newVal, oldVal) {
            if (!this.initialLoad) {

                this.$store.dispatch("order/fetchSalesCollectionByCustomer", {
                    customer: this.$route.params.id,
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    client: this.client,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },

        project(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("order/fetchSalesCollectionByCustomer", {
                    customer: this.$route.params.id,
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    client: this.client,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },

        selectedEmployee(newVal, oldVal) {
            if (!this.initialLoad) {

                this.$store.dispatch("order/fetchSalesCollectionByCustomer", {
                    customer: this.$route.params.id,
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    client: this.client,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        }
    },

    mounted() {
        this.$store.dispatch("client/fetchClient_without_pg")
        this.$store.dispatch("employee/fetchEmployeeList");
        this.$store.dispatch("department/fetchDepartments")
        this.$store.dispatch("project/fetchProject")

        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {

                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });

                this.fetchInitialEOD();
            } else {

                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);

                this.fetchInitialEOD();
            }
        }
    },

    methods: {
        getLine(invoice_id) {
            return this.lines.find(l => l.invoice_id === invoice_id)
        },
        fetchInitialEOD() {
            this.$store.dispatch("order/fetchSalesCollectionByCustomer", {
                customer: this.$route.params.id,
                perPage: this.perPage,
                currentPage: this.currentPage,
                start_date: this.start_date,
                end_date: this.end_date,
                search_term: this.filter,
                status: this.status,
                client: this.client,
                project: this.project,
                employee: this.selectedEmployee
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },
        toggleFilterShow() {
            this.filterShow = !this.filterShow
        },

        clearFilter() {
            this.filterShow = false,
                this.filter = null,
                this.start_date = null,
                this.end_date = null,
                this.status = '',
                this.client = '',
                this.project = '',
                this.selectedDepartment = '',
                this.selectedDesignation = '',
                this.selectedEmployee = ''
        },

        getStatus(status, id) {
            this.update_id = id
            this.selectedStatus = status
        },

        recordPayment(data) {
            this.record.invoice = data.item.id
            this.invoice_due = data.item.due_amount
        },

        resetModal() {
            this.record.paid_amount = ''
        },

        handleRecordOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleRecordSubmit()
        },

        handleRecordSubmit() {
            if (this.record.paid_amount > this.invoice_due) {
                Swal.fire({
                    title: "Error!",
                    text: 'Request amount is more than due amount!',
                    icon: "error"
                });
            } else {
                this.$store.dispatch("invoice/recordPayment", {
                    record: this.record,
                    currentPage: this.$route.query.page,
                    perPage: this.$route.query.perPage,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    client: this.client,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.record.paid_amount = '',
                            this.record.invoice = ''

                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })

                // Hide the modal manually
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-record')
                })
            }
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        deleteInvoice(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("invoice/deleteInvoice", {
                id: this.delete_value,
                currentPage: this.$route.query.page,
                perPage: this.$route.query.perPage,
                start_date: this.start_date,
                end_date: this.end_date,
                search_term: this.filter,
                status: this.status,
                client: this.client,
                project: this.project,
                employee: this.selectedEmployee
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("invoice/updateInvoiceStatus", {
                id: this.update_id,
                status_update: this.selectedStatus,
                currentPage: this.$route.query.page,
                perPage: this.$route.query.perPage,
                start_date: this.start_date,
                end_date: this.end_date,
                search_term: this.filter,
                status: this.status,
                client: this.client,
                project: this.project,
                employee: this.selectedEmployee
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.update_id = null
                    this.selectedStatus = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },
        confirmCollection() {
            this.form.date = moment(String(this.form.date)).format("YYYY-MM-DD");
            let collection = {
                customer: this.form.customer,
                office: this.form.office,
                employee: this.form.employee,
                payment_method: this.form.payment_method,
                cash_type: this.form.cash_type,
                money_receipt_no: this.form.money_receipt_no,
                date: this.form.date,
                remarks: this.form.remarks,
                lines: this.lines
            }
            this.$store.dispatch("order/confirmCollection", collection).then(response => {
                if (response.code == 201) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

        },
        createBill(){
            if (!this.selected || this.selected.length === 0) {
                Swal.fire({
                        title: "Error!",
                        text: 'Please select at least one invoice',
                        icon: "error"
                });
                
                return
            }
            let bill = {
                customer: this.$route.params.id,
                invoice_ids: this.selected
            }
            this.$store.dispatch("order/salesCreateBill", bill).then(response => {
                if (response.code == 201) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                this.selected = []

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },
    }
};
</script>
